import * as _ from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import {
  CheckboxLabel,
  CheckboxStyled
} from "src/library/components/Forms/Checkbox";
import Icon from "src/library/components/Icon/Icon";
import { IProductCategory } from "src/core/products/api/products.api";
import { Icons } from "src/library/components/Icon/types";

interface IProductCategorySelectProps {
  category: IProductCategory & { subCategories?: IProductCategory[] };
  selected: number[];
  onSelect: (id: number) => void;
}

const ProductCategorySelect: React.ReactFCWithChildren<IProductCategorySelectProps> = ({
  category, onSelect, selected
}) => {
  const [ showSub, setShowSub ] = React.useState<boolean>(false);
  const [ hasChildrenSelected, setHasChildrenSelected ] = React.useState<boolean>(false);
  let classNames = "category";

  if (category.subCategories && category.subCategories.length) {
    classNames += " has-children";
  }

  if (category.parentId) {
    classNames += " sub-cat";
  } else {
    classNames += " parent";
  }

  if (showSub) {
    classNames += " open";
  }

  if (hasChildrenSelected) {
    classNames += " children-selected";
  }

  React.useEffect(() => {
    if (category.subCategories && category.subCategories.length) {
      if (category.subCategories.find(cat => selected.includes(cat.id))) {
        setShowSub(true);
        setHasChildrenSelected(true);
      }
    }
  }, []);

  React.useEffect(() => {
    if (category.subCategories && category.subCategories.length) {
      if (category.subCategories.find(cat => selected.includes(cat.id))) {
        setHasChildrenSelected(true);

        return;
      }
    }

    setHasChildrenSelected(false);
  }, [ selected ]);

  return (
    <ProductCategorySelectWrapper
      className={classNames}
      direction="vertical"
    >
      <ProductCategoryWrapper
        className={classNames}
        valign="center"
      >
        {category.subCategories && category.subCategories.length > 0 && (
          <Icon
            icon={showSub ? Icons.CHEVRONUP : Icons.CHEVRONRIGHT}
            onClick={() => setShowSub(!showSub)}
          />
        )}

        <CheckboxLabel
          for={`category-${category.id}`}
          className="cat-label"
          label={category.name}
        >
          <CheckboxStyled
            className={`styled-checkbox ${selected.includes(category.id) ? "checked" : ""}`}
            onChange={() => onSelect(category.id)}
            name={`category-${category.id}`}
            id={`category-${category.id}`}
            checked={selected.includes(category.id) || false}
          />
        </CheckboxLabel>
      </ProductCategoryWrapper>

      {showSub &&
        _.map(category.subCategories, subCat => {
          return (
            <ProductCategorySelect
              key={subCat.id}
              category={subCat}
              selected={selected}
              onSelect={() => onSelect(subCat.id)}
            />
          );
        })}
    </ProductCategorySelectWrapper>
  );
};

const ProductCategoryWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    .cat-label {
      margin: 0;
    }
    margin-bottom: ${theme.spacing.padding.sm};
    &.open {
      padding-bottom: ${theme.spacing.padding.sm};
      border-bottom: 1px solid ${theme.colors.lightGrey};
    }

    &.parent:not(.has-children) {
      margin-left: 25px;
    }

    &.children-selected {
      .styled-checkbox:not(.checked) {
        &:after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: block;
          height: 2px;
          width: 10px;
          height: 2px;
          background: black;
          visibility: visible;
        }
      }
    }
  `}
`;

const ProductCategorySelectWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    &.sub-cat {
      margin-left: 45px;
    }

    &.open {
      margin-bottom: ${theme.spacing.padding.sm};
      border-bottom: 1px solid ${theme.colors.lightGrey};
    }
  `}
`;

export default ProductCategorySelect;
